import { Component, HostListener, Input, OnInit, SimpleChange, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FieldEnum, IFormField } from 'src/app/modules/shared/models/form-field';
import { CustomFormFieldService } from 'src/app/modules/shared/services/form-field.service';
import { CREATE_PO_FORMFIELDS, PO_HEADER_FORM_FIELDS } from '../../../constants/create-po-fields.constant';
import { PoApproverHelperService } from '../../../services/po-approver-helper.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';
import { Subscription, of, pairwise, startWith } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BuyerSupplierService } from '../../../services/buyer-supplier.service';
import { UI_ROUTES } from 'src/app/app.contant';
import { state } from '@angular/animations';
import { RfqService } from '../../../services/rfq/rfq.service';
import { qesService } from 'src/app/modules/shared/services/qes/qes.service';
import { file } from 'jszip';

export enum createEditPOTabType {
  PO_APPROVERS = "PO_APPROVERS",
  PO_ATTACHMENTS = "PO_ATTACHMENTS",
  PO_HISTORY = "PO_HISTORY",
  PO_HEADER_FIELDS = "PO_HEADER_FIELDS",
  PO_LINEITEM_FIELDS = "PO_LINEITEM_FIELDS"
}

export interface ICreatePOModalTabList {
  title: string,
  tabType: createEditPOTabType
};

interface FileSize {
  file: File,
  formatSize: string
}
@Component({
  selector: 'app-create-po-modal',
  templateUrl: './create-po-modal.component.html',
  styleUrls: ['./create-po-modal.component.scss']
})
export class CreatePoModalComponent implements OnInit {

  public title !: string;
  public qesData !: any;
  public vendorData !: any;
  public isBelowThreshold !: boolean;
  public ammendPo!: boolean;
  public POfieldsForm!: FormGroup;
  public POHeaderfieldsForm!: FormGroup;
  public POHeaderfieldsFormInitialValue!: any;
  public prData!: any;
  public prId!: any;
  public hideTab: any;
  private CONDITION_TYPE: any = {};
  public POfieldsFormFields: Array<IFormField> = CREATE_PO_FORMFIELDS;
  public POHeaderFields: Array<IFormField> = CREATE_PO_FORMFIELDS;
  public poAttachmentFiles: Array<FileSize> = [];
  public POfields: any[] = [];
  public initial_PO_values: any[] = [];
  public poHistory: any = [];
  public send_external: any = null;
  public test_run: any = null;
  public remarks !: string;
  public qesFiles: any = [];
  public rfqFiles: any = [];
  public totalPrice: any;
  selectedLineItemNo: any;
  amend_po_data: any[] = [];
  append:any;

  public _createPOTabList: Array<ICreatePOModalTabList> = [
    { title: "PO Approvers", tabType: createEditPOTabType.PO_APPROVERS },
    { title: "PO Header Fields", tabType: createEditPOTabType.PO_HEADER_FIELDS },
    { title: "PO LineItem Fields", tabType: createEditPOTabType.PO_LINEITEM_FIELDS },
    { title: "PO Attachments", tabType: createEditPOTabType.PO_ATTACHMENTS },
    { title: "Transaction Remarks", tabType: createEditPOTabType.PO_HISTORY }
  ];

  public activeTab: ICreatePOModalTabList = this._createPOTabList[0];

  /* PO approver variables */
  public poApproverDetails: any;

  public approvalList: any[] = [];
  public approvalList_1: any[] = [];
  public approvalList_2: any[] = [];
  public approvalList_3: any[] = [];
  public approvalList_4: any[] = [];
  public approvalList_5: any[] = [];
  public approvalList_6: any[] = [];
  public approvalList_7: any[] = [];
  public approvalList_8: any[] = [];
  public approvalList_9: any[] = [];
  public approvalList_10: any[] = [];
  public approvalListModel: number[] = [];
  public selectedApprovalList: any[] = [];
  public mySettings: IMultiSelectSettings = {
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-primary btn-block text-white me-2',
    dynamicTitleMaxItems: 0
  };
  public myTexts: IMultiSelectTexts = {
    defaultTitle: 'Select Approvers'
  };
  public pr_items: any = [];
  public po_data: any;
  public previousSelection: any;
  public control = new FormControl();
  public selectedLineItem: any;
  public payload_data: any[] = [];
  public enableCreatebtn: boolean = false;
  public isValidLineItem: any[] = [];
  public approver_1: any;
  public approver_2: any;
  public approver_3: any;
  public approver_4: any;
  public approver_5: any;
  public approver_6: any;
  public approver_7: any;
  public approver_8: any;
  public approver_9: any;
  public approver_10: any;
  public approver_11: any;
  public approver_12: any;
  public approvalList_11: any;
  public approvalList_12: any;
  public isAllApproverSelected: boolean = false
  public approvalListValues: any[] = [];
  public isTestRunDone: boolean = false;
  public hasErrorTypeE: boolean = true;
  STORAGE_LOCATION: any;
  public readonly ROUTES = UI_ROUTES;
  private fieldHistoryArray: any = [];
  public selectedLineItemIndex !: any;
  currentTime: string | undefined;
  today: string | undefined;
  amendPOData: any;
  selectedPurchaseOrders: any;
  public scheduleItem: any;
  poForm: FormGroup;
  filteredPoData: any;
  scheduleLineField: boolean = false;
  private routerSubscription!: Subscription;
  new_po_data: any[] = [];
  addRowdisable:boolean=false;

  constructor(public bsModalRef: BsModalRef,
    public _bsModalService: BsModalService,
    private _formFieldService: CustomFormFieldService,
    private _helperService: PrBuyerHelperService,
    private _toastrService: ToastrService,
    private fb: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _buyerSupplierService: BuyerSupplierService,
    private _router: Router,
    private _rfqService: RfqService,
    private _qesService: qesService,
    private _poApproverHelperService: PoApproverHelperService) {
    this.poForm = this.fb.group({
      poItems: this.fb.array([])
    });
  }

  public verifyFile(event: any): void {
    [...event.target.files].forEach((file: File) => {
      this.poAttachmentFiles.push({ file, formatSize: this._helperService.formatFileSize(file.size) });
    });
  }

  ngOnInit(): void {
    const getFormatDate = (val: any) => ('0' + val).slice(-2);
    this.today = `${new Date().getFullYear()}-${getFormatDate(new Date().getMonth() + 1)}-${getFormatDate(new Date().getDate())}`;
    this.currentTime = this._helperService.getLocalDateTime() ? new Date(this._helperService.getLocalDateTime()).toTimeString().substring(0, 5) : "";
    this._poApproverHelperService.getPOConditionType().subscribe(value => {
      this.CONDITION_TYPE.data = value.data.map((item: any) => { return { desc: item.type + ' - ' + item.text, code: item.type } });
    })
    if (this.ammendPo == true) {
      this.hideTabData();
    } else {
      this.fetchPOApproverDetails();
    } 
    if (this.prData[0].isAffiliated) {
      this._createPOTabList.splice(0, 1);
      this.activeTab = this._createPOTabList[0];
    }
    this.POfieldsFormFields = CREATE_PO_FORMFIELDS;
    this.POHeaderFields = PO_HEADER_FORM_FIELDS;
    this.POfieldsForm = this._formFieldService.createFormGroup(CREATE_PO_FORMFIELDS);
    this.prId = this._activatedRoute.snapshot.paramMap.get('prId');
    this.POHeaderfieldsForm = this._formFieldService.createFormGroup(PO_HEADER_FORM_FIELDS);
    this.POHeaderfieldsFormInitialValue = this.POHeaderfieldsForm.value;
    this.POHeaderfieldsForm.patchValue(["vendor_email_1", null]);
    this.POHeaderfieldsForm.patchValue(["vendor_email_2", null]);
    this.fetchPRDataForPOCreation();
    if (this.ammendPo == false) {
      this.fetchPOHistory();
    }
    this.control.valueChanges.pipe(
      startWith(this.control.value),
      pairwise()
    ).subscribe(
      ([old, value]) => {
        this.previousSelection = old;
      }
    );
    this.POfieldsForm.valueChanges.pipe(startWith(this.POfieldsForm.valid), pairwise()).subscribe(
      ([old, value]) => {
        const obj = this.pr_items.find((pr: any) => pr.value == this.selectedLineItem)
        const index = this.selectedLineItemIndex = this.pr_items.indexOf(obj);
        if (this.POfieldsForm.valid) {
          this.pr_items[index].isValid = true;
          this.po_data[index] = { ...this.POfieldsForm.getRawValue(), ...this.POHeaderfieldsForm.getRawValue() };
          this.control.enable();
          this.enableCreatebtn = this.pr_items.filter((pr: any) => pr.isValid == true).length == this.pr_items.length ? true : false;
        } else if (this.control.enabled) {
          this.enableCreatebtn = this.pr_items.filter((pr: any) => pr.isValid == true).length !== this.pr_items.length ? false : this.enableCreatebtn;
          this.control.disable();
        }
      })
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  checkDataType(data: any) {
    if (Array.isArray(data)) {
      this.selectedPurchaseOrders = data.map(item => {
        if (item.schedule_line === 'X') {
          this.scheduleLineField = true;
        }
        return item;
      });
    } else {
      this.selectedPurchaseOrders = [data];
    }

    if (this.selectedPurchaseOrders.some((item: any) => item.schedule_items && item.schedule_items.length > 0)) {
      this.ammendPo = true;
      this.scheduleItem = this.selectedPurchaseOrders.flatMap((item: any) =>
        item.schedule_items.map((scheduleItem: any) => ({
          ...scheduleItem,
          line_item_no: item.line_item_no,
          po_quantity: item.po_quantity
        }))
      ).filter((value: any, index: any, self: any) =>
        index === self.findIndex((t: any) => (
          t.id === value.id
        ))
      );

      // Update selectedPurchaseOrders with the modified schedule_items
      this.selectedPurchaseOrders = this.selectedPurchaseOrders.map((item: any) => {
        const updatedScheduleItems = item.schedule_items.map((scheduleItem: any) => ({
          ...scheduleItem,
          line_item_no: item.line_item_no,
          po_quantity: item.po_quantity
        }));

        return {
          ...item,
          schedule_items: updatedScheduleItems
        };
      });

      // Assign the updated selectedPurchaseOrders to prData
      this.prData = this.selectedPurchaseOrders;
      const firstIndex = this.prData[0].schedule_items
      this.initForm(firstIndex);
    } else {
      console.log("scheduleItem", this.scheduleItem);
    }
  }

  updatePoDataWithFormValues() {
    const poFields = this.POfieldsForm.getRawValue();
        const line_item_no = poFields.line_item_no;
        const item = this.po_data.find((data: any) => data.line_item_no === line_item_no);
        if (item) {
          item.po_quantity = poFields.po_quantity;
        }
    }

  initForm(scheduleItemsData?: any[], new_poData?: any) {
    const control = this.poForm.get('poItems') as FormArray;
    while (control.length !== 0) {
      control.removeAt(0);
    }
    console.log("new_poData", new_poData)

    if (scheduleItemsData && scheduleItemsData.length > 0) {
      scheduleItemsData.forEach((data: any) => {
        control.push(this.fb.group({
          delivery_counter: [data.delivery_counter],
          po_quantity: [data.po_quantity],
          delivery_date_category: ["D"],
          start_delivery_date: [this.formateDate(data.start_delivery_date)],
          delivery_time: [this.formatTimeHHmm(data.delivery_time)],
          custom_po_quantity: [data.custom_po_quantity, [
            Validators.required,
            this.customQuantityValidator(data.po_quantity),
          ]],
          static_delivery_date: [this.formatDateStatic(data.static_delivery_date)],
          pr_number: [{ value: data.pr_number, disabled: true }],
          pr_item: [{ value: data.line_item_no, disabled: true }],
          line_item_no: [{ value: data.line_item_no, disabled: true }],
          schedule_line: [data.schedule_line],
        }));
      });
    } else {
      this.updatePoDataWithFormValues();
      const match = this.selectedLineItem.match(/^\s*(\d+)-/);
      if (match) {
        const digitsBeforeHyphen = match[1];
        // Filter po_data based on the extracted digits
        this.filteredPoData = this.po_data.filter((data:any) => {
          const extractedDigits = data.line_item_no.split('-')[0];
          return extractedDigits === digitsBeforeHyphen;        
        });
      }
      this.filteredPoData.forEach((data: any, index: number) => {
        if (!data.schedule_items || data.schedule_items.length === 0) {
          control.push(this.fb.group({
            delivery_counter: [index + 1],
            po_quantity: new FormControl(data.po_quantity),
            delivery_date_category: new FormControl(data.delivery_date_category || 'D'),
            start_delivery_date: new FormControl(data.start_delivery_date),
            delivery_time: new FormControl(data.delivery_time),
            custom_po_quantity: new FormControl('', [
              Validators.required,
              this.customQuantityValidator(data.po_quantity),
            ]),
            static_delivery_date: new FormControl(data.static_delivery_date),
            pr_number: new FormControl({ value: data.pr_number, disabled: true }),
            pr_item: new FormControl({ value: data.line_item_no, disabled: true }),
            line_item_no: new FormControl(data.line_item_no),
            schedule_line: new FormControl(data.schedule_line || ''),
          }));
        }

        // If there are schedule_items, add them to the form
        if (data.schedule_items && data.schedule_items.length > 0) {
          data.schedule_items.forEach((scheduleItem: any) => {
            control.push(this.fb.group({
              delivery_counter: [scheduleItem.delivery_counter],
              po_quantity: [scheduleItem.po_quantity],
              delivery_date_category: [scheduleItem.delivery_date_category],
              start_delivery_date: [this.formateDate(scheduleItem.start_delivery_date)],
              delivery_time: [this.formatTimeHHmm(scheduleItem.delivery_time)],
              custom_po_quantity: [scheduleItem.custom_po_quantity, [
                Validators.required,
                this.customQuantityValidator(scheduleItem.po_quantity),
              ]],
              static_delivery_date: [this.formatDateStatic(scheduleItem.static_delivery_date)],
              pr_number: [{ value: scheduleItem.pr_number, disabled: true }],
              pr_item: [{ value: scheduleItem.pr_item, disabled: true }],
              line_item_no: [{ value: scheduleItem.line_item_no, disabled: true }],
              schedule_line: [scheduleItem.schedule_line]
            }));
          });
        }
      });
    }
    console.log("Initialized form with scheduleItemsData:", scheduleItemsData);
  }

  formateDate(date: string): string {
    if (!date) return '';
    const isFormatted = /^\d{4}-\d{2}-\d{2}$/.test(date);
    if (isFormatted) return date;

    const [day, month, year] = date.split('.');
    return `${year}-${month}-${day}`;
  }

  formatDate(date: string): string {
    if (!date) return '';

    const isFormatted = /^\d{2}\.\d{2}\.\d{4}$/.test(date);
    if (isFormatted) return date;

    const [year, month, day] = date.split('-');
    return `${day}.${month}.${year}`;
  }

  formatTimeHHmm(timeStr: any) {
    if (!timeStr) return timeStr;

    const match = timeStr.match(/^(\d{2})(\d{2})(\d{2})$/);
    if (match) {
      const [_, hours, minutes, _seconds] = match;
      return `${hours}:${minutes}`;
    }

    return timeStr;
  }

  formatDeliveryTime(deliveryTime: string): string {
    // Assuming deliveryTime is in the format "hh:mm:ss"
    const [hours, minutes, seconds] = deliveryTime.split(':');
    const formattedTime = `${hours}${minutes}${seconds}`;
    return formattedTime;
  }

  convertDateFormat(dateStr: any) {
    if (!dateStr) return dateStr;
    dateStr = dateStr.split(' ')[0];

    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const [_, year, month, day] = match;
      // return `${day}${month}${year}`;
      return `${year}${month}${day}`;
    }

    return dateStr;
  }

  formatDateStatic(dateStr: any) {
    if (!dateStr) return dateStr;

    const match = dateStr.match(/^(\d{4})(\d{2})(\d{2})$/);
    if (match) {
      const [_, year, month, day] = match;
      return `${year}-${month}-${day}`;
    }

    return dateStr;
  }

  convertDateFormatStatic(dateStr: any) {
    if (!dateStr) return dateStr;

    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const [_, year, month, day] = match;
      return `${year}${month}${day}`;
    }
    return dateStr;
  }

  formatDeliveryTimeCreate(timeStr: any) {
    if (!timeStr) return '';

    const isFormatted = /^\d{2}\d{2}\d{2}$/.test(timeStr);
    if (isFormatted) return timeStr;

    const hours = timeStr.substring(0, 2);
    const minutes = timeStr.substring(3, 5);
    return `${hours}${minutes}00`;
  }

  customQuantityValidator(availableQuantity: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const customQuantity = parseFloat(control.value);
      const availableQty = parseFloat(availableQuantity);
      if (!isNaN(customQuantity) && customQuantity > availableQty) {
        return { 'exceedsPoQuantity': true };
      }
      return null;
    };
  }
  deleteRow(index: number): void {
    this.poItems.removeAt(index);
  }

  calculateTotalQuantity(): number {
    let totalQuantity = 0;
    // this.poItems.controls.forEach((item: any) => {
    //   totalQuantity = parseFloat(item.get('po_quantity').value) || 0;
    // });
    const poFields = this.POfieldsForm.getRawValue();
    const poQuantityValue = parseInt(poFields.po_quantity);
    if (!isNaN(poQuantityValue)) {
    totalQuantity += poQuantityValue;
    }
    return totalQuantity;
  }

  getAvailableQuantity(index: number): number {
    if (this.poItems && this.poItems.controls[index]) {
      const poQuantity = parseFloat(this.poItems.controls[index].get('po_quantity')?.value) || 0;
      const customPoQuantityControl = this.poItems.controls[index].get('custom_po_quantity');
      const customPoQuantity = parseFloat(customPoQuantityControl ? customPoQuantityControl.value : '0'); // Default to '0' if null
      if (!isNaN(customPoQuantity)) {
        return poQuantity - customPoQuantity;
      }
    }
    return 0;
  }

  isCustomQuantityValid(custom_po_quantity: string, po_quantity: number): boolean {
    const customQuantity = parseFloat(custom_po_quantity);
    return customQuantity < po_quantity;
  }

  get poItems() {
    return this.poForm.get('poItems') as FormArray;
  }

  addRow() {
    const control = this.poForm.get('poItems') as FormArray;
    let previousRow: any;
    let poQuantity = 0;
    let customPoQuantity = 0;

    if (control.length > 0) {
      previousRow = control.at(control.length - 1);
      poQuantity = previousRow.get('po_quantity')?.value || 0;
      customPoQuantity = parseFloat(previousRow.get('custom_po_quantity')?.value) || 0;
    }

    const availableQuantity = poQuantity - customPoQuantity;
    const poQuantityControl = new FormControl(availableQuantity);

    control.push(this.fb.group({
      delivery_counter: [control.length + 1],
      po_quantity: poQuantityControl,
      delivery_date_category: [''],
      start_delivery_date: [''],
      delivery_time: [''],
      custom_po_quantity: ['', [
        Validators.required,
        this.customQuantityValidator(availableQuantity.toString())
      ]],
      available_quantity: [{ value: availableQuantity, disabled: true }],
      static_delivery_date: [''],
      pr_number: [{ value: previousRow.get('pr_number')?.value || '', disabled: true }],
      pr_item: [{ value: previousRow.get('pr_item')?.value || '', disabled: true }],
      line_item_no: [{ value: previousRow?.get('line_item_no')?.value || '', disabled: true }]
    }));
  }

  public clearFile(file: any): void {
    this.poAttachmentFiles = this.poAttachmentFiles.filter((x: FileSize) => x.file.name !== file.file.name);
  }

  public hideTabData() {
    if (this.hideTab == "Amend line item") {
      this.append = true;
      this._createPOTabList.splice(0, 1);
      this.hideTab = this._createPOTabList[0];
      this.activeTab = this._createPOTabList[1];
    } else if (this.hideTab == "Amend Header Level") {
      this.append = false;
      this._createPOTabList.splice(0, 1);
      this.activeTab = this._createPOTabList[0];
    } else {
      this.append = false;
      this._createPOTabList.splice(0, 1);
      this.activeTab = this._createPOTabList[0];
    }
  }

   // Function to handle clicks outside of the table
   @HostListener('document:click', ['$event'])
   clickOutside(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const isClickedOutside = !clickedElement.closest('.table-container');
    const poFields = this.POfieldsForm.getRawValue();

    if (isClickedOutside) {
      if (poFields.schedule_line === 'X') {
        this.scheduleLineField = true;
      } else if (poFields.schedule_line === 'Y') {
        this.scheduleLineField = false;
      }
    }
  }

  saveFormData() {
    const formArrayData = this.poItems.getRawValue();

    if (this.ammendPo == true) {
      console.log("this.prData", this.prData)
      this.prData.forEach((item:any)=>{
        if(item.item_category != 'Service'){
          if (item.schedule_line === 'X') {
            this.scheduleLineField = true;
          }else if (item.schedule_line === 'Y') {
            this.scheduleLineField = false;
          }
        }else{
          this.scheduleLineField = false;
          this.POfieldsForm.get("po_quantity")?.enable();
        }
      })

      const groupedFormItems = formArrayData.reduce((acc: any, formItem: any) => {
        if (!acc[formItem.line_item_no]) {
          acc[formItem.line_item_no] = [];
        }
        acc[formItem.line_item_no].push(formItem);
        return acc;
      }, {});
      
      // Iterate through prData and replace schedule_items with grouped form items
      this.prData.forEach((existingItem: any) => {
        const lineItemNo = existingItem.line_item_no;
      
        if (groupedFormItems[lineItemNo]) {
          existingItem.schedule_items = groupedFormItems[lineItemNo];
      
          // Ensure each formItem includes line_item_no
          existingItem.schedule_items.forEach((item: any) => {
            if (!item.line_item_no) {
              item.line_item_no = lineItemNo;
            }
          });
        }
      });
      console.log("after adding this.prData", this.prData)

      // Sort this.prData by line_item_no
      this.prData.sort((a: any, b: any) => a.line_item_no.localeCompare(b.line_item_no));

      this.prData.forEach((prItem: any) => {
        if (prItem.schedule_items) {
          prItem.schedule_items = prItem.schedule_items.map((scheduleItem: any) => {
            const formattedStartDate = this.formatDate(scheduleItem.start_delivery_date);
            const formattedStaticDate = this.convertDateFormatStatic(scheduleItem.static_delivery_date);
            const formattedDeliveryTime = this.formatDeliveryTimeCreate(scheduleItem.delivery_time);
            const formattedCustomPoQuantity = parseFloat(scheduleItem.custom_po_quantity).toString();
            let pr_number = null;
            if(scheduleItem.pr_number){
              if(scheduleItem.pr_number.length >= 9){
                pr_number = scheduleItem.pr_number
              }
            }
            const updatedScheduleItem = {
              ...scheduleItem,
              pr_item: null,
              pr_number: pr_number,
              delivery_time: formattedDeliveryTime,
              delivery_counter: scheduleItem.delivery_counter.toString(),
              po_quantity: scheduleItem.po_quantity.toString(),
              custom_po_quantity: formattedCustomPoQuantity,
              start_delivery_date: formattedStartDate === "" ? null : formattedStartDate,
              static_delivery_date: formattedStaticDate === "" ? null : formattedStaticDate
            };
            delete updatedScheduleItem.line_item_no;
            delete updatedScheduleItem.schedule_line;
            delete updatedScheduleItem.available_quantity;
            return updatedScheduleItem;
          });
        }
      });
      const poFields = this.POfieldsForm.getRawValue();
      console.log('Updated poData after filtering repetition', this.prData);
      const poFieldsArray = Array.isArray(poFields) ? poFields : [poFields];

      poFieldsArray.forEach((poItem: any) => {
        const lineItemIndex = this.prData.findIndex((data: any) => data.line_item_no === poItem.line_item_no);
        
        if (lineItemIndex !== -1) {
          // Update the existing item in prData with the values from poItem
          this.prData[lineItemIndex] = { ...this.prData[lineItemIndex], ...poItem };
        }
      });
      console.log('Updated poData after filtering repetition', this.prData);
      this.amend_po_data = [...this.prData];

    } else {
      formArrayData.forEach((formItem: any) => {
        const lineItemIndex = this.po_data.findIndex((data: any) => data.line_item_no === formItem.line_item_no);

        // if (lineItemIndex > -1) {
        const existingItem = this.po_data[lineItemIndex];
        if (existingItem.schedule_items) {
          const scheduleItemIndex = existingItem.schedule_items.findIndex((item: any) => item.line_item_no === formItem.line_item_no && item.delivery_counter === formItem.delivery_counter);
          if (scheduleItemIndex === -1) {
            existingItem.schedule_items.push(formItem);
          } else {
            existingItem.schedule_items[scheduleItemIndex] = formItem;
          }
        } else {
          existingItem.schedule_items = [formItem];
        }
        // } else {
        //   this.po_data.push({
        //     ...formItem,
        //     schedule_items: [formItem],
        //   });
        // }
      });

      this.po_data.sort((a: any, b: any) => parseInt(a.line_item_no, 10) - parseInt(b.line_item_no, 10));

      this.po_data.forEach((item: any) => {
        if (item.schedule_items) {
          const uniqueDeliveryCounters = new Set();
          item.schedule_items = item.schedule_items.filter((scheduleItem: any) => {
            const deliveryCounterNumber = parseInt(scheduleItem.delivery_counter);
            if (isNaN(deliveryCounterNumber)) {
              return false;
            }
            if (uniqueDeliveryCounters.has(deliveryCounterNumber)) {
              return false;
            } else {
              uniqueDeliveryCounters.add(deliveryCounterNumber);
              return true;
            }
          });
        }
      });
      console.log('Updated poData after filtering repetition', this.po_data);
      this.new_po_data = [...this.po_data];
    }

  }

  private fetchPOHistory() {
    let fetchPOHistoryBody;
    fetchPOHistoryBody = {
      "prId": this.prData[0]?.prId.prId ? this.prData[0]?.prId.prId : this.prData[0]?.prId
    };
    this._poApproverHelperService.fetchPOhistory(fetchPOHistoryBody).subscribe((res: any) => {
      this.poHistory = res?.data;
      if (this.poHistory?.length) {
        this.poHistory.map((value: any) => {
          try {
            value.reponse_message = eval(value?.reponse_message)
          } catch (e) {
            value.reponse_message = [{ MESSAGE: value?.reponse_message.toString() }];
          }

        });
      }
      this._toastrService.success(res.message);
    }, (err: any) => {
      this._toastrService.error(err.error.message);
    });
  }

  public getPOfieldsFormControl(prop: string): FormControl {
    return this.POfieldsForm.get(prop) as FormControl;
  }

  public getPOHeaderfieldsFormControl(prop: string): FormControl {
    return this.POHeaderfieldsForm.get(prop) as FormControl;
  }

  public getFieldValues() {
    let getFieldValuesPrId;
    getFieldValuesPrId = this.prData[0]?.prId.prId? this.prData[0]?.prId.prId : this.prData[0]?.prId;
    this._poApproverHelperService.getAllAttachments(getFieldValuesPrId, this.po_data[0].vendor_number).subscribe((res: any) => {
      if (res.status == 200) {
        this.rfqFiles = res.data.rfq_files;
        this.qesFiles = res.data.qes_files;
      }
    });
    [...CREATE_PO_FORMFIELDS].forEach((x: IFormField) => {
      if (x.fieldType === FieldEnum.SELECT && x.selectFields?.apiAsync$) {
        if (x.fieldName === "document_type") {
          this._poApproverHelperService.getPODocumentType().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.type + ' - ' + item.type_text, code: item.type } });
            if (x?.selectFields) {
              // x.selectFields.apiAsync$ = of(value);
              const defaultValue = value.data.find((item:any) => item.code === 'NB');
              x.selectFields.apiAsync$ = of(value).pipe(startWith(defaultValue));
            }
          });
        }
        if (x.fieldName === "packing_code") {
          this._poApproverHelperService.getPOPackingCode().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.code + ' - ' + item.text, code: item.code } });
            if (x?.selectFields) {
              x.selectFields.apiAsync$ = of(value);
            }
          });
        }
        if (x.fieldName === "tax_code") {
          this._buyerSupplierService.getTaxCodes().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.code + ' - ' + item.description, code: item.code } });
            if (x?.selectFields) {
              // x.selectFields.apiAsync$ = of(value);
              const defaultValue = value.data.find((item:any) => item.code === 'JI');
              x.selectFields.apiAsync$ = of(value).pipe(startWith(defaultValue));
            }
          });
        }
        if (x.fieldType === FieldEnum.SELECT && x.selectFields?.apiAsync$ && x.fieldName === "conf_ctrl") {
          this._poApproverHelperService.getPOConfCtrl().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.conf_ctrl + ' - ' + item.text, code: item.conf_ctrl } });
            if (x?.selectFields) {
              x.selectFields.apiAsync$ = of(value);
            }
          });

        }
        if (x.fieldType === FieldEnum.SELECT && x.selectFields?.apiAsync$ && x.fieldName === "storage_location") {
          this._poApproverHelperService.getStorageLoaction(this.po_data[0].plant).subscribe(value => {
            this.STORAGE_LOCATION = value.data;
            value.data = value.data.map((item: any) => { return { desc: item.STORAGE_LOCATION + ' - ' + item.STORAGE_LOCATION_DESC, code: item.STORAGE_LOCATION } });
            if (x?.selectFields) {
              x.selectFields.apiAsync$ = of(value);
            }
          });

        }
        if (x.fieldName.includes("cond_type")) {
          if (x?.selectFields) {
            x.selectFields.apiAsync$ = of(this.CONDITION_TYPE);
          };
        }
      }
      if (x.disabled) this.POfieldsForm.controls[x.fieldName].disable();
    });

    [...PO_HEADER_FORM_FIELDS].forEach((x: IFormField) => {
      if (x.fieldType === FieldEnum.SELECT && x.selectFields?.apiAsync$) {
        if (x.fieldName === "shipping_code") {
          this._poApproverHelperService.getPOShippingCode().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.code + ' - ' + item.text, code: item.code } });
            if (x?.selectFields) {
              x.selectFields.apiAsync$ = of(value);
            }
          });
        }
        if (x.fieldName === 'vendor_email_1') {
          if (this.po_data[0].vendor_email_1.length) {
            let value = this.po_data[0].vendor_email_1.map((email: any) => { return { desc: email, code: email } });
            x.selectFields.dataFields = value;
            this.po_data[0].vendor_email_1 = this.po_data[0].vendor_email_1[0];
          } else {
            x.selectFields.dataFields = [];
          }
        }
        if (x.fieldName === 'vendor_email_2') {
          if (this.po_data[0].vendor_email_1.length) {
            let value = this.po_data[0].vendor_email_2.map((email: any) => { return { desc: email, code: email } });
            x.selectFields.dataFields = value
            this.po_data[0].vendor_email_2 = this.po_data[0].vendor_email_2[0];
          } else {
            x.selectFields.dataFields = [];
          }
        }
        if (x.fieldName === "partner_code") x.selectFields.apiAsync$ = this._poApproverHelperService.getPOPartnerCode();
        if (x.fieldName === "clause") {
          this._poApproverHelperService.getPOClause().subscribe(value => {
            value.data = value.data.map((item: any) => { return { desc: item.clause + ' - ' + item.description, code: item.clause } });
            if (x?.selectFields) {
              x.selectFields.apiAsync$ = of(value);
            }
          });
        }

        if (x.fieldName === "GBK") x.selectFields.apiAsync$ = this._poApproverHelperService.getPOGBK();
      }
      if (x.disabled) this.POHeaderfieldsForm.controls[x.fieldName].disable();
    });
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
    // this._router.navigateByUrl(`${this.ROUTES.HOME}`,{state:{selectedTab:4}});
  }

  public changeTab(tab: ICreatePOModalTabList): void {
    this.saveFormData();
    this.activeTab = tab;
    if (this.ammendPo == true) {
    if(this.prData[0].item_category != 'Service'){
      if(this.prData[0].schedule_line == 'X'){
        this.addRowdisable = true;
        this.POfieldsForm.get("po_quantity")?.disable();
        this.POfieldsForm.get("schedule_line")?.disable();
        this.poForm.disable();
      }else{
        this.addRowdisable = false;
        this.POfieldsForm.get("po_quantity")?.enable();
        this.POfieldsForm.get("schedule_line")?.enable();
        this.poForm.enable();
      }
    }else{
      this.disableFields(this.prData[0].item_category);
      this.scheduleLineField = false;
      this.POfieldsForm.get("po_quantity")?.enable();
    }
   }
    this.POHeaderfieldsForm.markAllAsTouched();
    this.POfieldsForm.markAllAsTouched();
    this.validateApproverSelection();
    const gri_value = this.POfieldsForm.controls["goods_receipt_indicator"].value;
    this.POfieldsForm.controls["goods_receipt_indicator"].patchValue(gri_value);
    this.POfieldsForm.updateValueAndValidity();
  }

  private getLineItemFormData(index: number): any {
    // Assuming lineItemNo is a property of the form data, you can retrieve it accordingly.
    const lineItemNo = this.pr_items[index]?.value;

    if (this.selectedLineItemNo === lineItemNo) {
      return this.POfieldsForm.getRawValue();
    }
    return {};
  }

  public createPO(isTestRun: boolean) {
    this.saveFormData();
    this.fieldHistoryArray.forEach((item:any)=>{
      if(item.field_name == "vendor_email_1" || item.field_name == "vendor_email_2"){
        item.old_value = "";
      }
    })
    this._poApproverHelperService.poFieldHistoryUpdate(this.fieldHistoryArray).subscribe((res: any) => {
      if (res.status == 200) {
        if (this.ammendPo == true) {
          // this.amendPOData[0].prId = this.amend_po_data[0].prId;
          console.log("amend_po_data", this.amend_po_data);

          const headerData = this.POHeaderfieldsForm.getRawValue();
          // Update each entry in po_data based on line item no
          this.po_data = this.amend_po_data.map((data: any, index: number) => {
            const lineItemFormData = this.getLineItemFormData(index);
            data.terms_of_payment = data.payment_terms;
            if(data.schedule_line != 'X'){
              delete data.schedule_items;
            }
            return {
              ...data,
              ...headerData,
              ...lineItemFormData,
              vendor_email_1: Array.isArray(data.vendor_email_1) ? data.vendor_email_1.toString() : data.vendor_email_1,
              vendor_email_2: Array.isArray(data.vendor_email_2) ? data.vendor_email_2.toString() : data.vendor_email_2,
              seqNo: Number(data.seqNo)
            };
          });

          const float_values = ["net_price", "gross_price", "po_quantity", "quantity_or_percentage", "service_quantity", "service_net_price",];
          const cond_values = ["cond_value_1", "cond_value_2", "cond_value_3", "cond_value_4"];
          this.po_data.map((item: any) => {
          const prData = item;
            prData.test_run = isTestRun ? "X" : null;
            prData.id = null;
            prData.seqNo = 1;
            prData.quotation_date = prData.quotation_date ? prData.quotation_date.includes('T') ? prData.quotation_date.split('T')[0].replace(/-/g, "") : prData.quotation_date.replace(/-/g, "") : prData.quotation_date;
            prData.delivery_date = prData.delivery_date ? prData.delivery_date.replace(/-/g, "") : prData.delivery_date;

            float_values.forEach((value) => {
              if (prData[value]) {
                if (typeof prData[value] == 'number' && !isNaN(prData[value])) {
                  prData[value] = Number.isInteger(prData[value]) ? `${prData[value]}.00` : prData[value];
                }
              }
            });

            cond_values.forEach((value, index) => {
              if (prData[value] && typeof (prData[value]) === 'number') {
                // if (prData["cond_type" + (index + 1)] && prData["cond_type" + (index + 1)].includes('%')) {
                prData[value] =  Number.isInteger(prData[value]) ? `${prData[value]}.00` : prData[value];
                // `${parseInt(prData[value])}.00`
              }
            })
            this.POfields.push(prData);
          });

          console.log("final amend podata",this.po_data)
          const supportDocument = {
            rfq_files: this.rfqFiles.length ? this.rfqFiles : [],
            qes_files: this.qesFiles.length ? this.qesFiles : [],
          }
          let attachedFile = this.poAttachmentFiles;
          const formData = new FormData();
          formData.append("poData", JSON.stringify(this.po_data));
          formData.append("supportDocument", JSON.stringify(supportDocument));
          formData.append("files", JSON.stringify(attachedFile));
          this._poApproverHelperService.changePO(formData).subscribe((res: any) => {
            if (res.status == 200) {
              if (isTestRun == true) {
                this.testRunResponse(res);
              } else {
                if(res.data.sapResponse.length == 1){
                  this.isTestRunDone = true;
                  this._toastrService.success(res.data.sapResponse[0].MESSAGE);
                  this.onModalClose();
                  this._router.navigateByUrl(`${this.ROUTES.HOME}`, { state: { selectedTab: 4 } });
                }else{
                  this.isTestRunDone = false;
                  this._helperService.successErrorPOCreationModal(res);
                }
                // this.onModalClose();
              }
            } else {
              console.log(res);
            }
          }, err => {
            if (err) {
              // this.isTestRunDone = false;
              this._helperService.failedPOCreationModal(err);
            } else {
              this._toastrService.error("Changing of Purchase Order : Something went wrong")
            }
          });
        } else {
          this.POfields = [];
          const firstPrNumber = null;
          const firstPrItem = null;
          console.log("Initial poData", this.po_data);
          this.po_data = this.new_po_data
          const headerData = this.POHeaderfieldsForm.getRawValue();
          // Update each entry in po_data based on line item no
          this.po_data = this.po_data.map((data: any, index: number) => {
            const lineItemFormData = this.getLineItemFormData(index);
            return {
              ...data,
              ...headerData,
              ...lineItemFormData
            };
          });

          console.log("Initial poData", this.po_data);
          this.po_data.forEach((po: any) => {
            if (Array.isArray(po.vendor_email_1) && po.vendor_email_1.length > 0) {
              po.vendor_email_1 = po.vendor_email_1[0];
            }
            if (Array.isArray(po.vendor_email_2) && po.vendor_email_2.length > 0) {
              po.vendor_email_2 = po.vendor_email_2[0];
            }
            if (po.schedule_items) {
              po.schedule_items = po.schedule_items.map((scheduleItem: any) => {
                const {
                  available_quantity,
                  custom_po_quantity,
                  delivery_time,
                  schedule_line,
                  // line_item_no,
                  ...itemWithoutAvailableQuantity
                } = scheduleItem;

                const formattedStartDate = this.formatDate(scheduleItem.start_delivery_date);
                const formattedStaticDate = this.convertDateFormatStatic(scheduleItem.static_delivery_date);
                const formattedDeliveryTime = this.formatDeliveryTimeCreate(scheduleItem.delivery_time);

                return {
                  ...itemWithoutAvailableQuantity,
                  pr_item: scheduleItem.pr_item ? scheduleItem.pr_item : firstPrItem,
                  delivery_time: formattedDeliveryTime,
                  pr_number: scheduleItem.pr_number ? scheduleItem.pr_number : firstPrNumber,
                  delivery_counter: scheduleItem.delivery_counter.toString(),
                  po_quantity: scheduleItem.po_quantity.toString(),
                  custom_po_quantity: custom_po_quantity ? parseFloat(custom_po_quantity).toFixed(2) : "0",
                  start_delivery_date: formattedStartDate === "" ? null : formattedStartDate,
                  static_delivery_date: formattedStaticDate === "" ? null : formattedStaticDate
                };
              });
            }
            if(po.schedule_line != 'X'){
              delete po.schedule_items;
            }

          });
          console.log("Final poData", this.po_data);

          const float_values = ["net_price", "gross_price", "po_quantity", "quantity_or_percentage", "service_quantity", "service_net_price",];
          const cond_values = ["cond_value_1", "cond_value_2", "cond_value_3", "cond_value_4"];
          this.po_data.forEach((po: any) => {
            const prData = po;
            prData.test_run = isTestRun ? "X" : null;
            prData.id = null;
            prData.seqNo = 1;
            prData.quotation_date = prData.quotation_date ? prData.quotation_date.includes('T') ? prData.quotation_date.split('T')[0].replace(/-/g, "") : prData.quotation_date.replace(/-/g, "") : prData.quotation_date;
            prData.delivery_date = prData.delivery_date ? prData.delivery_date.replace(/-/g, "") : prData.delivery_date;

            float_values.forEach((value) => {
              if (prData[value]) {
                
                if (typeof prData[value] == 'number' && !isNaN(prData[value])) {
                  prData[value] = Number.isInteger(prData[value]) ? `${prData[value]}.00` : prData[value];
                }
              }
              // else {
              //   prData[value] = value === "net_price" ? `0.00` : null;
              // }
            });

            cond_values.forEach((value, index) => {
              if (prData[value] && typeof (prData[value]) === 'number' && !isNaN(prData[value])) {
                // if (prData["cond_type" + (index + 1)] && prData["cond_type" + (index + 1)].includes('%')) {
                prData[value] = Number.isInteger(prData[value]) ? `${prData[value]}.00` : prData[value];
              }
              // else{
              //   prData[value] = 0.00;
              // }
            })

            this.POfields.push(prData);

            // this.POfields.forEach((field: any) => {
            //   Object.assign(field, prData);
            // });

          })
          const formData = new FormData();
          for (var i = 0; i < this.poAttachmentFiles.length; i++) {
            formData.append("files", this.poAttachmentFiles[i].file);
          }
          formData.append(`approver_1`, this.approvalListValues[0] ? JSON.stringify(this.approvalListValues[0]) : '');
          formData.append(`approver_2`, this.approvalListValues[1] ? JSON.stringify(this.approvalListValues[1]) : '');
          formData.append(`approver_3`, this.approvalListValues[2] ? JSON.stringify(this.approvalListValues[2]) : '');
          formData.append(`approver_4`, this.approvalListValues[3] ? JSON.stringify(this.approvalListValues[3]) : '');
          formData.append(`approver_5`, this.approvalListValues[4] ? JSON.stringify(this.approvalListValues[4]) : '');
          formData.append(`approver_6`, this.approvalListValues[5] ? JSON.stringify(this.approvalListValues[5]) : '');
          formData.append(`approver_7`, this.approvalListValues[6] ? JSON.stringify(this.approvalListValues[6]) : '');
          formData.append(`approver_8`, this.approvalListValues[7] ? JSON.stringify(this.approvalListValues[7]) : '');
          this.po_data[0].send_external = this.send_external;
          formData.append("prData", JSON.stringify(this.po_data));
          formData.append("prId", JSON.stringify(this.prData[0]?.prId.prId ? this.prData[0]?.prId.prId : this.prData[0]?.prId));
          const otherFiles = {
            rfq_files: this.rfqFiles.length ? this.rfqFiles.map((file: any) => { return file.id }) : [],
            qes_files: this.qesFiles.length ? this.qesFiles.map((file: any) => { return file.id }) : [],
          }
          formData.append("supportDocument", JSON.stringify(otherFiles))
          this._poApproverHelperService.createPO(this.POfields, formData, this.isBelowThreshold).subscribe((res: any) => {
            if (res.status == 200) {
              this._toastrService.success(res.message);
              if (isTestRun == true) {
                this.testRunResponse(res);
              } else {
                if (res.data.sapResponse.length && res.data.sapResponse[0].MESSAGE == "PO is created Successfully") {
                  this.isTestRunDone = true;
                  this._toastrService.success(res.data.sapResponse[0].MESSAGE);
                  this.onModalClose();
                  this._router.navigateByUrl(`${this.ROUTES.HOME}`, { state: { selectedTab: 4 } });
                } else {
                  // this.isTestRunDone = false;
                  this.isTestRunDone = false;
                  this._helperService.successErrorPOCreationModal(res);
                }
              }

              // this.onModalClose();
            } else {
              console.log(res)
            }
          }, err => {
            if (err) {
              this._helperService.failedPOCreationModal(err);
              this.hasErrorTypeE = false
            } else {
              this._toastrService.error("Creation of Purchase Order : Something went wrong")
            }
          });
        }
      } else {
        console.log(res)
      }
    })
  }

  public testRunResponse(res: any) {

    const hasErrorTypeE = res.data.sapResponse.some((response: any) => response.TYPE === 'E');
    this.hasErrorTypeE = hasErrorTypeE;

    if (res.data.sapResponse.length == 1 && (res.data.sapResponse[0].MESSAGE == '"Create Purchase Order" function performed in test run' || res.data.sapResponse[0].MESSAGE == '"Change Purchase Order" function performed in test run')) {
      this.isTestRunDone = true;
      let success = res.data.sapResponse[0].MESSAGE;
      this._helperService.successPOCreationModal(success);
  } else if(res.data.sapResponse.length == 1){
    this.isTestRunDone = true;
    let success = res.data.sapResponse[0].MESSAGE;
    this._helperService.successPOCreationModal(success);
  } else {
      this.isTestRunDone = false;
      this._helperService.successErrorPOCreationModal(res);
    }
  }


  public bindValues(fieldName: string) {
    if (fieldName === "document_condition_code") {
      const con_type = this.CONDITION_TYPE.filter((res: any) => res.CONDITION_TEXT == this.POHeaderfieldsForm.get('document_condition_code')?.value);
      this.POHeaderfieldsForm.get('document_condition_type')?.patchValue(con_type[0].CONDITION_TYPE || null);
      this.POHeaderfieldsForm.controls['document_condition_type'].markAsTouched();
    }
  }

  public fetchPRDataForPOCreation() {
    let fetchPRDataForPOCreationprId;
    if (this.isBelowThreshold && this.ammendPo == false) {
      fetchPRDataForPOCreationprId = this.prData[0].prId.prId ?  this.prData[0].prId.prId :  this.prData[0].prId;
      console.log("this.vendorData", this.vendorData)
      this._poApproverHelperService.fetchBelowThresholdPoValues(fetchPRDataForPOCreationprId, this.vendorData).subscribe((res: any) => {
        this._toastrService.success(res.message);
        this.POfields = res.data;
        this.initial_PO_values = JSON.parse(JSON.stringify(res.data))

        this.pr_items = res.data.map((data: any) => {
          return { value: data.line_item_no + "-" + data.material, isValid: false };
        });
        
        this.pr_items.sort((a: any, b: any) => {
          const numA = parseInt(a.value.split('-')[0]); 
          const numB = parseInt(b.value.split('-')[0]); 
          return numA - numB; // Sort in ascending order
        });
        
        console.log("pr_items (sorted):", this.pr_items);

        this.selectedLineItem = this.pr_items[0].value;
        this.po_data = res.data;
        console.log("poData", this.po_data);
        this.checkDataType(this.po_data);
        // required for po ammend fields
        this.getFieldValues();
        this.POHeaderfieldsForm.patchValue(res.data[0]);
        this.POfieldsForm.patchValue(res.data[0]);
        this.POfieldsForm.controls["delivery_date"].markAsTouched();
        this.disableFields(res.data[0].item_category);
        this.POHeaderfieldsForm.markAllAsTouched();
      }, err => {
        this._toastrService.error(err.error.message);
      });
    } else if (this.ammendPo == true) {
      this.initial_PO_values = this.POfields = JSON.parse(JSON.stringify(this.prData));
      this.po_data = JSON.parse(JSON.stringify(this.prData));
      this.remarks = JSON.parse(JSON.stringify(this.remarks));
      let updatePoPayload;
      if (this.remarks != "") {
        updatePoPayload = {
          prId: this.prData[0].prId.prId,
          po_number: this.prData[0].po_number,
          line_item_no: null,
          remarks: this.prData[0].prId.remarks,
        }
        this._poApproverHelperService.updatePo(updatePoPayload.prId, updatePoPayload.po_number, updatePoPayload.line_item_no, updatePoPayload.remarks).subscribe((res: any) => {
          console.log("update po", res);
        })
      }
      this.pr_items = this.prData.map((data: any) => { return { value: data.line_item_no + "-" + data.material, isValid: false } });

      this.pr_items.sort((a: any, b: any) => {
        const numA = parseInt(a.value.split('-')[0]); 
        const numB = parseInt(b.value.split('-')[0]); 
        return numA - numB; // Sort in ascending order
      });

      this.selectedLineItem = this.pr_items[0].value;
      console.log("this.prData intial", this.prData)
      if(this.prData[0].item_category != 'Service'){
        if(this.prData[0].schedule_line == 'X'){
          this.addRowdisable = true;
          this.POfieldsForm.get("po_quantity")?.disable();
          this.POfieldsForm.get("schedule_line")?.disable();
          this.poForm.disable();
        }else{
          this.addRowdisable = false;
          this.POfieldsForm.get("po_quantity")?.enable();
          this.POfieldsForm.get("schedule_line")?.enable();
          this.poForm.enable();
        }
      }else{
        this.disableFields(this.prData[0].item_category);
        this.scheduleLineField = false;
        this.POfieldsForm.get("po_quantity")?.enable();
      }
      this.checkDataType(this.prData);
      this.getFieldValues();
      this.POHeaderfieldsForm.patchValue(this.prData[0]);
      this.POfieldsForm.patchValue(this.prData[0]);
      this.POfieldsForm.controls["delivery_date"].markAsTouched();
      this.disableFields(this.prData[0].item_category);
      this.POHeaderfieldsForm.markAllAsTouched();
      this.POfieldsForm.markAllAsTouched();
    } else {
      let prId;
      prId = this.prData[0].prId.prId ? this.prData[0].prId.prId :this.prData[0].prId;

      this._poApproverHelperService.fetchPRDataForPOCreation(this.qesData?.id, prId).subscribe((res: any) => {
        this._toastrService.success(res.message);
        this.POfields = res.data;
        this.initial_PO_values = JSON.parse(JSON.stringify(res.data));
        this.pr_items = res.data.map((data: any) => { return { value: data.line_item_no + "-" + data.material, isValid: false } });
        this.pr_items.sort((a: any, b: any) => {
          const numA = parseInt(a.value.split('-')[0]); 
          const numB = parseInt(b.value.split('-')[0]); 
          return numA - numB; // Sort in ascending order
        });
        this.selectedLineItem = this.pr_items[0].value;
        this.po_data = res.data;
        this.getFieldValues();
        this.POHeaderfieldsForm.patchValue(res.data[0]);
        this.POfieldsForm.patchValue(res.data[0]);
        this.disableFields(res.data[0].item_category)
      }, err => {
        this._toastrService.error(err.message);
      });
    }
  }

  public onPrItemChange(event: any, lineItemNo: any) {
    console.log(" this.POfieldsForm", this.POfieldsForm);
    this.saveFormData();
    this.scheduleLineField = true;
    const currentSelectionIndex = this.pr_items.findIndex((pr: any) => pr.value === lineItemNo);
    if (currentSelectionIndex !== -1) {
      const currentData =  this.new_po_data[currentSelectionIndex]?this.new_po_data[currentSelectionIndex] :this.amend_po_data[currentSelectionIndex];
      this.disableFields(currentData.item_category);
      if (!currentData.schedule_line) {
        currentData.schedule_line = '';
        this.scheduleLineField = false;
      }else if(currentData.schedule_line === 'X') {
        this.scheduleLineField = true;
      }else if (currentData.schedule_line === 'Y') {
        this.scheduleLineField = false;
      }
      const { schedule_items, ...rest } = currentData;

      rest.info_record_note = currentData.info_record_note ?? '';
      rest.info_record_po_text = currentData.info_record_po_text ?? '';
      rest.service_line_item_no = currentData.service_line_item_no ?? '';

      // if (currentData.item_category == "Service"){
      //   rest.conf_ctrl = '';
      //   rest.order_ack = '';
      // }

      this.POfieldsForm.patchValue(rest);

      // Check if schedule_items should be added
      if (schedule_items) {
        this.initForm(schedule_items);
      }
    }
    const obj = this.pr_items.find((pr: any) => pr.value == this.previousSelection)
    const i = this.pr_items.indexOf(obj)//previous selection
    if (this.POfieldsForm.valid) {
      this.po_data[i] = { ...this.POfieldsForm.getRawValue(), ...this.POHeaderfieldsForm.getRawValue() };
      this.POfieldsForm.reset();
      const currentSelection = this.pr_items.find((pr: any) => pr.value == lineItemNo)
      const currentIndex = this.pr_items.indexOf(currentSelection);
      this.POfieldsForm.patchValue(this.po_data[currentIndex]);//current selection
      this.disableFields(this.po_data[currentIndex].item_category)
        if(this.ammendPo == true){
        if(this.po_data[currentIndex].item_category != 'Service'){
          if(this.po_data[currentIndex].schedule_line == 'X'){
            this.addRowdisable = true;
            this.POfieldsForm.get("po_quantity")?.disable();
            this.POfieldsForm.get("schedule_line")?.disable();
            this.poForm.disable();
          }else{
            this.addRowdisable = false;
            this.POfieldsForm.get("po_quantity")?.enable();
            this.POfieldsForm.get("schedule_line")?.enable();
            this.poForm.enable();
          }
        }else{
        this.disableFields(this.po_data[currentIndex].item_category);
        this.scheduleLineField = false;
        this.POfieldsForm.get("po_quantity")?.enable();
        }
      }
      this.POfieldsForm.markAllAsTouched();
    } else {
      this.POfieldsForm.markAllAsTouched();
      event.stopPropagation();
      event.preventDefault();
    }
    this.selectedLineItemNo = lineItemNo;
  }

  private fetchPOApproverDetails() {
    let createPOPayload;

    console.log(this.prData);
    
    createPOPayload = {
      "document_type": "NB",//this.prData[0].document_type,
      "net_price": this.prData[0].total_cost ? this.prData[0].total_cost : this.prData[0].total_price ? this.prData[0].total_price  : this.prData.total_finalPrice,
      "purchase_org": this.prData[0].prId.purchasing_organization ?this.prData[0].prId.purchasing_organization:this.prData[0].purchasing_organization,
      "purchase_group": this.prData[0].prId.purchasing_group ?this.prData[0].prId.purchasing_group:this.prData[0].purchasing_group
    };
    this._poApproverHelperService.fetchPOApproverDetails(createPOPayload).subscribe((res: any) => {
    
      if (res.data.length) {
        this.poApproverDetails = [...new Set([].concat(...res.data.map((approvalList: any) => approvalList)))];
        this._toastrService.success(res.message);
        this.approvalList_1 = this.poApproverDetails.filter((approver: any) => approver.code == "01");
        this.approvalList_2 = this.poApproverDetails.filter((approver: any) => approver.code == "02");
        this.approvalList_3 = this.poApproverDetails.filter((approver: any) => approver.code == "03");
        this.approvalList_4 = this.poApproverDetails.filter((approver: any) => approver.code == "04");
        this.approvalList_5 = this.poApproverDetails.filter((approver: any) => approver.code == "05");
        this.approvalList_6 = this.poApproverDetails.filter((approver: any) => approver.code == "06");
        this.approvalList_7 = this.poApproverDetails.filter((approver: any) => approver.code == "07");
        this.approvalList_8 = this.poApproverDetails.filter((approver: any) => approver.code == "08");
        this.approvalList_9 = this.poApproverDetails.filter((approver: any) => approver.code == "09");
        this.approvalList_10 = this.poApproverDetails.filter((approver: any) => approver.code == "10");
        this.approvalList_11 = this.poApproverDetails.filter((approver: any) => approver.code == "11");
        this.approvalList_12 = this.poApproverDetails.filter((approver: any) => approver.code == "12");
        this.approvalList = [...new Map(res.data.map((item: any) => [item['gid'], { 'name': item.approver_name, 'id': item.gid }])).values()];
      } else {
        this._toastrService.success(res.message);
        this.isAllApproverSelected = true;
      }
    }, (err: any) => {
      this._toastrService.error(err.message);
      this.isAllApproverSelected = true;
    });

  }

  public onChange(params: any) {
    var selectedApprover = this.poApproverDetails.find((approver: any) => approver.id == params.value);
    this.selectedApprovalList.push(selectedApprover);
    // this._poApproverHelperService.getItracerUserInfo([selectedApprover.username]).subscribe((res:any)=>{
    if (params) {
      // selectedApprover = {...selectedApprover}
      if (selectedApprover.code == "01")
        this.approver_1 = selectedApprover
      else if (selectedApprover.code == "02")
        this.approver_2 = selectedApprover
      else if (selectedApprover.code == "03")
        this.approver_3 = selectedApprover
      else if (selectedApprover.code == "04")
        this.approver_4 = selectedApprover
      else if (selectedApprover.code == "05")
        this.approver_5 = selectedApprover
      else if (selectedApprover.code == "06")
        this.approver_6 = selectedApprover
      else if (selectedApprover.code == "06")
        this.approver_6 = selectedApprover
      else if (selectedApprover.code == "07")
        this.approver_7 = selectedApprover
      else if (selectedApprover.code == "08")
        this.approver_8 = selectedApprover
      else if (selectedApprover.code == "09")
        this.approver_9 = selectedApprover
      else if (selectedApprover.code == "10")
        this.approver_10 = selectedApprover
      else if (selectedApprover.code == "11")
        this.approver_11 = selectedApprover
      else if (selectedApprover.code == "12")
        this.approver_12 = selectedApprover
    }
    // })
  }

  public validateApproverSelection() {
    if (this.approvalList_1.length) {
      this.isAllApproverSelected = this.approver_1 ? true : false;
    }
    if (this.approvalList_2.length) {
      this.isAllApproverSelected = this.approver_2 ? true : false;
    }
    if (this.approvalList_3.length) {
      this.isAllApproverSelected = this.approver_3 ? true : false;
    }
    if (this.approvalList_4.length) {
      this.isAllApproverSelected = this.approver_4 ? true : false;
    }
    if (this.approvalList_5.length) {
      this.isAllApproverSelected = this.approver_5 ? true : false;
    }
    if (this.approvalList_6.length) {
      this.isAllApproverSelected = this.approver_6 ? true : false;
    }
    if (this.approvalList_7.length) {
      this.isAllApproverSelected = this.approver_7 ? true : false;
    }
    if (this.approvalList_8.length) {
      this.isAllApproverSelected = this.approver_8 ? true : false;
    }
    if (this.approvalList_9.length) {
      this.isAllApproverSelected = this.approver_9 ? true : false;
    }
    if (this.approvalList_10.length) {
      this.isAllApproverSelected = this.approver_10 ? true : false;
    }
    if (this.approvalList_11.length) {
      this.isAllApproverSelected = this.approver_11 ? true : false;
    }
    if (this.approvalList_12.length) {
      this.isAllApproverSelected = this.approver_12 ? true : false;
    }
    this.approvalListValues = [this.approver_1, this.approver_2, this.approver_3, this.approver_4, this.approver_5, this.approver_6, this.approver_7, this.approver_8, this.approver_9, this.approver_10, this.approver_11, this.approver_12].filter((approver: any) => approver != undefined);
  }

  private disableFields(itemCategory: string) {
    if (itemCategory == 'Standard') {
      this.POfieldsForm.get("service_line_item_no")?.disable();
      this.POfieldsForm.get("service_master")?.disable();
      this.POfieldsForm.get("service_quantity")?.disable();
      this.POfieldsForm.get("service_UoM")?.disable();
      this.POfieldsForm.get("service_net_price")?.disable();
      // this.POfieldsForm.get("short_text")?.enable();
      this.POfieldsForm.get("gross_price")?.disable();
      this.POfieldsForm.get("schedule_line")?.enable();
    } else if (itemCategory == 'Service') {
      this.POfieldsForm.get("schedule_line")?.disable();
      this.POfieldsForm.get("service_quantity")?.enable();
      this.POfieldsForm.get("service_UoM")?.enable();
      this.POfieldsForm.get("service_net_price")?.enable();
      this.POfieldsForm.get("gross_price")?.enable();
      this.POfieldsForm.get("service_line_item_no")?.disable();
      // this.POfieldsForm.get("order_ack")?.disable();
      // this.POfieldsForm.get("conf_ctrl")?.disable();
    }
  }

  deleteRfqQesFile(index: any, type: any) {
    if (type === 'rfq') {
      this.rfqFiles.splice(index, 1);
    } else if (type === 'qes') {
      this.qesFiles.splice(index, 1);
    }
  }

  downloadRFQfile(f: any) {
    if (f.rfq_template_id) {
      this._rfqService.downloadRFQTemplateAttachment(f.id).subscribe((res: any) => {
        this._helperService.saveFileData(res, f.name);
      });
    } else {
      this._qesService.downloadQesAttachmnet(f.id).subscribe((res: any) => {
        // const blob = new Blob([res], { type: "octet/stream" });
        // const element = document.createElement('a');
        // element.href = URL.createObjectURL(blob);
        // element.download = `${row?.name}${row?.format}`;
        // document.body.appendChild(element);
        // element.click();
        this._helperService.saveFileData(res, f.name);
      });
    }
  }

  onChangeInputs(tab_name: any, field_name: any, event: any) {
    this.saveFormData();
    console.log("this.new_po_data", this.new_po_data)
    if (field_name == "schedule_line" && event.target.value == "X") {
      this.scheduleLineField = true;
      if(this.selectedLineItemNo == undefined){
        this.initForm();
      }else if(this.selectedLineItemNo) {
        console.log("this.selectedLineItemNo;", this.selectedLineItemNo)
        const line_item_no = this.selectedLineItemNo;
        const firstTwoDigits = line_item_no.slice(0, 2);
        console.log("new po_data", this.new_po_data);
        if (field_name == "schedule_line" && event.target.value == "X") {
          this.scheduleLineField = true;
          const matchingItem = this.new_po_data.find((item: any) => item.line_item_no === firstTwoDigits);
          if (matchingItem) {
            if (matchingItem.schedule_items) {
              const scheduleItems = matchingItem.schedule_items || [];
              // this.scheduleItem.clear();
              // scheduleItems.forEach((scheduleItem: any) => {
              //   this.scheduleItem.push(this.fb.group({
              //     // Define the form controls based on scheduleItem properties
              //   }));
              // });
              this.initForm(scheduleItems);
            } else {
              this.initForm();
            }
          }
          else {
            this.initForm();
          }
        }
      } else if(this.scheduleItem) {
        // this.initForm(this.scheduleItem,);
        if (this.scheduleItem && Array.isArray(this.scheduleItem)) {
          const allSame = this.scheduleItem.every(item => item.line_item_no === this.scheduleItem[0].line_item_no);
          if (allSame) {
            this.initForm(this.scheduleItem);
          } else {
            let schedule_items = this.new_po_data[0].schedule_items
            this.initForm(schedule_items);
          }
        }
      } else {
        this.initForm();
      }
    } else {
      this.scheduleLineField = false;
    }
    const modifiedValue = {
      tab_name: tab_name,
      field_name: field_name,
      action: "changed",
      new_value: event.target.value,
      old_value: tab_name == "header" ? this.initial_PO_values[0][field_name] : this.initial_PO_values[this.selectedLineItemIndex][field_name],
      created_date: this.today,
      created_time: this.currentTime,
      line_item_no: tab_name != "header" ? this.selectedLineItem.toString().split('-')[0] : "",
      pr_number: this.prData[0].pr_number,
      prId: this.prData[0]?.prId.prId ? this.prData[0]?.prId.prId : this.prData[0]?.prId,
      po_number: this.prData[0].po_number
    }
    if (this.fieldHistoryArray?.length) {
      const hasField = this.fieldHistoryArray.filter((input: any) => input.field_name == field_name);
      if (hasField.length) {
        const indx = this.fieldHistoryArray.map(function (e: any) { return e.field_name }).indexOf(field_name);
        this.fieldHistoryArray[indx] = modifiedValue
      } else {
        this.fieldHistoryArray.push(modifiedValue)
      }
    } else {
      this.fieldHistoryArray.push(modifiedValue)
    }
  }
}
